import { Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef,  MAT_BOTTOM_SHEET_DATA, } from '@angular/material/bottom-sheet';
import { StorageService } from 'src/app/core/store/storage/storage.service';
import { FeedbackSnackbarService } from 'src/app/core/utilities/feedback-snackbar/feedback-snackbar.service';
import { UserFacadeService } from 'src/app/facades/user/user-facade.service';

@Component({
  selector: 'app-cancel-deletion',
  templateUrl: './cancel-deletion.component.html',
  styleUrls: ['./cancel-deletion.component.scss']
})
export class CancelDeletionComponent implements OnInit {
  userId: number;
  value: any;

  constructor(
    private bottom: MatBottomSheet,
    private bottomSheet: MatBottomSheetRef<CancelDeletionComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private storageService: StorageService,
    private userFacadeService: UserFacadeService,
    private snackBar: FeedbackSnackbarService,
  ) { 
    this.userId = data.id ;
  }

  ngOnInit(): void {
  }

  close() {
    this.bottomSheet.dismiss();
  }

  cancelDeleteSubscription() {
    const data = { id: this.userId };
    this.userFacadeService.cancelDeleteAccount(data).subscribe({
      next: (response) => {
        if (response === 'Success') {
          this.bottom.dismiss();
          this.snackBar.successSnackbar('Account deletion canceled successfully!');
          window.location.reload();
        } else {
          this.snackBar.successSnackbar('Something went wrong, please try again.');
        }
      },
      error: (error) => {
        this.snackBar.errorSnackbar('Server error. Please try later.');
      }
    });
  }

}